import { ICalendarConfig } from "@core/services/interfaces/geralEmplacamento/calendar/ICalendarService";

const calendarConfig: ICalendarConfig = {
  // Endpoints
  getBlockedDatesEndpoint: "/api/Geral/Calendario/ObterDatasBloqueadas",
  isWorkingDayEndpoint: "/api/Geral/Calendario/EhDiaUtil",
};

export default calendarConfig;
